import React, { useContext } from "react"

export const SearchRecipeContext = React.createContext()

export const useSearchRecipes = () => {
    return useContext( SearchRecipeContext )
}